var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    viewBox: "0 -52 100 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "35.488,0 25.306,10.182 58.836,43.712 0,43.712 0,58.112 58.836,58.112 25.306,91.641 35.488,101.823      86.399,50.912 ",
    fill: "#FEC325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmyArrow);
export default __webpack_public_path__ + "static/media/armyArrow.bbe901dcf888085fbe8619307e86a430.svg";
export { ForwardRef as ReactComponent };